import React, { useRef, useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import '../../ContextMenu.scss';

let c=0;

const ContextMenu = ({children, dropdownPos, setDropdownPos, className}) => { 
    let ref = useRef(undefined);
    let mouseDown = useRef(false);
    let mouseUps = useRef(0);
    let id = useRef(++c);

    useEffect(() => {
        if (ref.current) {
            ref.current.addEventListener('mousewheel', onWheel);
        }
        return () => {
            if (ref.current) {
                ref.current.removeEventListener('mousewheel', onWheel);
            }
        }
    }, [dropdownPos]);

    const onWheel = useCallback((e) => {
        e.stopPropagation();
    }, []);

    useEffect(() => {
        window.addEventListener("mouseup", clear);
        return () => {
            window.removeEventListener("mouseup", clear);
        };
    }, [setDropdownPos, dropdownPos]);

    const clear = useCallback(() => {
        mouseUps.current++;
        if (mouseUps.current === 1 && mouseDown.current) {
            mouseDown.current=false; 
            return;
        }
        if (setDropdownPos) {
            // mouseUps.current = 0;
            mouseDown.current=false; 
            setDropdownPos(undefined);
        }
    }, [setDropdownPos, dropdownPos]);

    useEffect(() => {
        if (!dropdownPos) {
            mouseUps.current = 0;
            mouseDown.current=false;
        } else {
            mouseUps.current = 0;
            mouseDown.current=true;
        }
    }, [dropdownPos]);
    
    if (!dropdownPos) {
        mouseUps.current = 0;
        return [];
    }

    return (
        <div
          onMouseDown={e => {
          }}
          ref={ref} style={
            {
                left: dropdownPos.x - 10,
                top: dropdownPos.y - 10
            }}
          onMouseUp={(e) => {
              // mouseDown.current=false; 
          }}
          onClick={() => {
          }}
          className={"context-menu " + className}>
          {children}
        </div>);
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ContextMenu);
